export enum projectMenuEnum {
    overview = 31,
    landParcelTable,
    propertyDetailsHouses,
    propertyDetailsOthers,
    ResidentialRental,
    RetailRental,
    OfficeRental,
    WarehouseRental,
    ResidentialRentalAnalysis,
    RetailRentalAnalysis,
    OfficeRentalAnalysis,
    landPrices,
    propertyPrices,
    unitPrices,
    municipalRegulations
}
export const DisableAnchorCategories = [
  'industry_workshop_warehouse', // add more later if needed
];
